var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.components[_vm.componentName],{tag:"component",staticClass:"crafted-component",class:_vm.content.props.classes,style:(_vm.content.props.styles),attrs:{"props":_vm.content.props,"children":_vm.content.children,"content":_vm.content}},[(_vm.content.children.length)?_vm._l((_vm.content.children),function(element,index){return _c('recursion',{key:index,attrs:{"content":element,"componentName":element.props.component
          ? element.props.component
          : element.componentName}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }